import Vue from 'vue'
import 'babel-polyfill'
import VueCookies from 'vue-cookies'
import axios from 'axios'
import './assets/css/quilleditor/quill.bubble.css'
import './assets/css/quilleditor/quill.core.css'
import './assets/css/quilleditor/quill.snow.css'
import elementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import 'swiper/css/swiper.min.css'
import './assets/css/common.css'
import * as echarts from 'echarts'
import App from './App.vue'
import router from './router'

import VideoPlayer from 'vue-video-player'
import 'vue-video-player/src/custom-theme.css'
import 'video.js/dist/video-js.css'

import { post, postByX, get, put } from './assets/js/http';

// VueCookies.config('2min') // 设置cookie过期时间 设置为0时 关闭浏览器即销毁
Vue.use(VueCookies)
Vue.use(elementUI)
Vue.use(VideoPlayer)

Vue.config.productionTip = false
Vue.prototype.$echarts = echarts
Vue.prototype.$post = post
Vue.prototype.$postByX = postByX
Vue.prototype.$get = get
Vue.prototype.$put = put

router.beforeEach((to,from,next)=>{
	if(to.meta.title){
		document.title=to.meta.title
	}
	next()
})

new Vue({
  axios,
  router,
  render: h => h(App),
}).$mount('#app')
